import React, { useContext, useState } from "react";
import { Row, Col, Modal } from "react-bootstrap";
import { Link } from "react-router-dom";
import {
  CardMonitoring,
  TitleCardMonitoring,
  TabletIcon,
  TitleBoxOne,
  TitleBoxTwo,
  TagMonitoring,
  Measure,
  IconMeasure,
  LimitMeasure,
  RealMeasure,
  InsideLimitMeasure,
  TagInfo,
  LastReading,
  Ellipse,
  NoRead,
  ButtonSend,
  ColCard,
} from "./styles";
import Signal from "../../../../components/signal/signal";
import Lights from "../../../../components/lights/lights";
import Battery from "../../../../components/battery/battery";
import moment from "moment";
import { versionCollector } from "../../../../../components/data/versionCollector";
import { Context } from "../../../../../services/context";
import Toggle from "../../../../../components/toggle";
import { HiOutlineCog6Tooth } from "react-icons/hi2";
import { LuCalendarClock } from "react-icons/lu";
import CardScheduling from "../../../../components/cardscheduling";
import { useRoutine } from "../../../../../hooks/routine.hook";
import RenderIconMeasuere from "../../../../../utils/renderIconMeasuere";
import { TfiMapAlt } from "react-icons/tfi";

export function MonitoringCard({ item, key, md = 3 }) {
  const { setViewSismogran, setNickname, setIsAutomation, setExpandScheduling } = useContext(Context);
  const { sendCommand, loading } = useRoutine();
  const [toggle, setToggle] = useState(false);

  const toggleButton = () => setToggle(!toggle);

  return (
    <ColCard>
      <div onClick={() => {
        if (!item.automation) {
          setNickname(item.nickname);
          setViewSismogran(item.id);
          setIsAutomation(false);
        }
      }
      } role="button">
        <CardMonitoring automation={item.automation} type={item.monitor_environment} className="mb-3">
          <TitleCardMonitoring>
            {/* {item.monitor_environment === "coletor de automação" && "AAA"} */}
            <TitleBoxOne title={item.nickname}>
              <TabletIcon src="../../../media/icons/tablet.svg" />
              {item.nickname}
            </TitleBoxOne>
            <TitleBoxTwo>
              {
                item.automation
                  ?
                  <div className="d-flex align-self-center mr-3">
                    <HiOutlineCog6Tooth style={{ fontSize: '17pt', }} onClick={() => {
                      setNickname(item.nickname);
                      setViewSismogran(item.id);
                      setIsAutomation(true);
                      setExpandScheduling(false);
                    }
                    } />
                    <LuCalendarClock className="icon-automation" style={{ marginTop: 1 }} onClick={() => {
                      toggleButton();
                    }
                    } />
                  </div>
                  :
                  <div className="d-flex">
                    {
                      item.sensors.map(sensor => {
                        if (sensor.name_measure?.toLowerCase().includes("gps")) {
                          return (
                            <TfiMapAlt
                              key={sensor.id}
                              style={{ fontSize: '17pt' }}
                              onClick={() => {
                                setNickname(item.nickname);
                                setViewSismogran(item.id);
                              }}
                            />
                          );
                        }
                        return <div></div>;
                      })
                    }
                    <Signal
                      signal={item.signal_quality}
                      network={item.network}
                      situation={item.situation}
                    />
                    <Battery
                      level={item.batterylevel}
                      signal={
                        item.situation === "SUCCESS"
                          ? 1
                          : item.situation === "WARNING"
                            ? 2
                            : item.situation === "DANGER"
                              ? 3
                              : item.situation === "DARK"
                                ? 4
                                : 5
                      }
                    />
                  </div>
              }
              <Lights
                message={item.message}
                signal={
                  item.situation === "SUCCESS"
                    ? 1
                    : item.situation === "WARNING"
                      ? 2
                      : item.situation === "DANGER"
                        ? 3
                        : item.situation === "DARK"
                          ? 4
                          : 5
                }
              />
            </TitleBoxTwo>
          </TitleCardMonitoring>
          <TagMonitoring automation={item.automation} type={item.monitor_environment}>
            {!item.monitor_environment
              ? "Coletor de equipamento"
              : "Coletor de ambiente"}
          </TagMonitoring>
          <Row className="m-2">
            {item.sensors?.length === 0 ? (
              <Col md={12}>
                <NoRead>Sem leituras</NoRead>
              </Col>
            ) : (
              item.sensors?.map((sens) => (
                <Col>
                  <Measure>
                    <div className="d-flex justify-content-center">
                      <RealMeasure>
                        {RenderIconMeasuere(sens.name_measure ?? sens.profile_attribute?.unit_of_measure?.measure?.name)}
                        {/* <IconMeasure
                          src={
                            sens.name_measure === "Temperatura"
                              ? "../../../media/icons/temperature.svg"
                              : "../../../media/icons/humidity.svg"
                          }
                        /> */}
                        <div style={{
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'center',
                          justifyContent: 'center'
                        }}>
                          <span style={{ fontWeight: 'bold' }}>
                            {(sens.value !== undefined && sens.value !== null
                              ? Number(sens.value).toFixed(2)
                              : "0.00")}
                          </span>

                          {
                            sens.name_unitOfMeasure
                              ?
                              <p style={{ margin: 0, marginTop: -5, fontSize: '8pt', color: 'rgba(0,0,0,0.6)' }}>
                                {!sens.name_unitOfMeasure
                                  ? ''
                                  : sens.name_measure == 'Umidade'
                                    ? ' %' + sens.name_unitOfMeasure
                                    : sens.name_measure
                                }
                              </p>
                              :
                              <p style={{ margin: 0, marginTop: -5, fontSize: '8pt', color: 'rgba(0,0,0,0.6)' }}>
                                {sens.profile_attribute?.unit_of_measure?.measure?.name &&
                                  (sens.name_measure === "Umidade"
                                    ? ` %${sens.profile_attribute.unit_of_measure.measure.name}`
                                    : ` ${sens.profile_attribute.unit_of_measure.measure.name}`)}
                              </p>
                          }
                        </div>
                      </RealMeasure>

                      {
                        item.automation &&
                        <div className="ml-3" style={{ width: 90, marginTop: 3 }}>
                          <Toggle
                            labelTrue="ON"
                            labelFalse="OFF"
                            isAutomation
                            loading={loading}
                            value={item.automation.status}
                            onChange={(val) => {
                              if (typeof val === 'object') {
                                sendCommand({
                                  id_contract_item: item.id,
                                  btn: val.toggled,
                                  setpoint: val.setpoint
                                }, () => { });
                              }
                            }}
                          />
                        </div>
                      }
                    </div>

                    <LimitMeasure>
                      <InsideLimitMeasure>
                        <strong>Min</strong>
                        <span>{sens.min}</span>
                      </InsideLimitMeasure>
                      <InsideLimitMeasure>
                        <strong>Máx</strong>
                        <span>{sens.max}</span>
                      </InsideLimitMeasure>
                    </LimitMeasure>
                  </Measure>
                  <div className="d-flex justify-content-center">
                    <small style={{ textAlign: 'center' }}>{sens.name_measure}</small>
                  </div>
                </Col>
              ))
            )}
          </Row>
          <TagInfo automation={item.automation}>
            <strong>Coletor: </strong> {item.serial}{" "}
            <Ellipse src="../../../media/icons/ellipse.svg" />
            <strong>Tag: </strong>{" "}
            {versionCollector.filter((fill) => fill.value === item.version)
              .length === 0
              ? "Nenhuma"
              : versionCollector
                .filter((fill) => fill.value === item.version)
                .map((version) => version.label)}
          </TagInfo>
          <LastReading>
            <strong>Última leitura:</strong>{" "}
            {!item.updated_at
              ? "Sem leituras"
              : moment(item.updated_at).format("DD/MM/YY HH:mm:ss")}
          </LastReading>
        </CardMonitoring>
      </div>

      <Modal show={toggle} onHide={toggleButton} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>
            Cadastro de rotina
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <CardScheduling automation={item.automation} />
        </Modal.Body>
      </Modal>
    </ColCard>
  );
}
